import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectImplantPlanTable(state),
        type: 'implant-plan',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryImplantPlan,
    changeFilter: action.changeFilterImplantPlan,
    toggleSort: action.toggleSortImplantPlan,
    toggleMultiSort: action.toggleMultiSortImplantPlan,
    gotoPage: action.gotoPageImplantPlan,
    initialColumnsVisibility: action.initialTableSettingsImplantPlan,
    toggleColumnVisibility: action.toggleColumnVisibilityImplantPlan,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/ImplantPlanSalesOrderSearchContainer.js